import React, { useState } from "react";
import {
    Button,
    Form,
    Grid,
    Header,
    Image,
    Segment,
    InputProps
} from "semantic-ui-react";
import { withRouter, RouteComponentProps } from "react-router-dom";

import UsuarioRepository from "../../Repositories/UsuarioRepository";
import { Login } from "../../services/auth";

import logo from "../../assets/logo.png";
import errors from "../../Utils/ExtractErrors";
import { toast } from "react-toastify";

type PathParamsType = {};

type Props = RouteComponentProps<PathParamsType> & {};

type State = {
    usuario: string;
    senha: string;
    error: string;
};

const Logon: React.FC<Props> = ({ history }) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<State>({
        usuario: "",
        senha: "",
        error: "FALHA AO EFETUAR LOGIN, VERIFIQUE SUAS CREDENCIAIS.",
    });

    const handleSignIn = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setLoading(true);

        if (!state.usuario && !state.senha) {
            setState({
                ...state,
                error: "FALHA AO EFETUAR LOGIN, VERIFIQUE SUAS CREDENCIAIS.",
            });
            toast(state.error, { position: "top-center", type: "error" });
        } else {
            try {
                const response = await UsuarioRepository.LogIn({
                    login: state.usuario,
                    senha: state.senha
                });
                Login(response.token);
                history.push("/app");
            } catch (err) {
                const error = errors.getRawErrors(err.response.data, "ApiError") || [{ message: "FALHA AO EFETUAR LOGIN, VERIFIQUE SUAS CREDENCIAIS." }];
                setState({
                    ...state,
                    error: error[0].message,
                });
                toast(state.error, { position: "top-center", type: "error" });
            }
        }

        setLoading(false);
    };

    return (
        <Grid
            className="swing-in-bottom-bck"
            textAlign="center"
            style={{ height: "100vh" }}
            verticalAlign="middle"
        >
            <Grid.Column style={{ maxWidth: 450 }}>
                <Form size="large" onSubmit={handleSignIn}>
                    <Segment
                        raised
                        color="pink">
                        <Header as="h2" color="teal" textAlign="center">
                            <Image src={logo} style={{ height: 65, width: 200 }} />
                        </Header>
                        <Form.Input
                            fluid
                            icon="user"
                            iconPosition="left"
                            placeholder="Seu login"
                            onChange={(e: InputProps) =>
                                setState({
                                    ...state,
                                    usuario: e.target.value,
                                })
                            }
                        />
                        <Form.Input
                            fluid
                            icon="lock"
                            iconPosition="left"
                            placeholder="Sua senha secreta"
                            type="password"
                            onChange={(e: InputProps) =>
                                setState({
                                    ...state,
                                    senha: e.target.value,
                                })
                            }
                        />
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Button
                                    icon="trash"
                                    content="Limpar"
                                    type="reset"
                                    color="grey"
                                    size="large"
                                    fluid
                                    loading={loading}
                                    disabled={loading || state.usuario.length === 0}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Button
                                    icon="sign in"
                                    content="Entrar"
                                    type="submit"
                                    color="pink"
                                    size="large"
                                    loading={loading}
                                    disabled={loading || state.usuario.length === 0}
                                    fluid
                                />
                            </Form.Field>
                        </Form.Group>
                    </Segment>
                </Form>
            </Grid.Column>
        </Grid>
    );
};

export default withRouter(Logon);
